import { Duration, intervalToDuration } from 'date-fns';

export const secondsToDuration = (totalSeconds: number) => {
    const startDate = new Date(0);
    const endDate = new Date(totalSeconds * 1000);

    if (startDate.getTime() === endDate.getTime()) {
        return {
            years: 0,
            months: 0,
            weeks: 0,
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        } as Duration;
    }

    return intervalToDuration({
        start: startDate,
        end: endDate,
    });
};

export const durationToSeconds = (duration: Duration): number => {
    const daysInSeconds = (duration.days ?? 0) * 86400;
    const hoursInSeconds = (duration.hours ?? 0) * 3600;
    const minutesInSeconds = (duration.minutes ?? 0) * 60;
    const seconds = duration.seconds ?? 0;

    return daysInSeconds + hoursInSeconds + minutesInSeconds + seconds;
};

export const toIsoStringIgnoreTimezone = (date: Date): string => {
    const pad = (n: number): string => n.toString().padStart(2, '0');

    return (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}` +
        '.000Z'
    );
};

export const floorToSecond = (date: Date): Date => {
    const floored = new Date(date.getTime());
    floored.setMilliseconds(0);
    return floored;
};
